// Copyright (c) 2021 WiseTime. All rights reserved.

import { Observable, of } from "rxjs"
import { catchError, filter, map, mergeMap } from "rxjs/operators"
import { Action } from "redux"
import {
  ReorderFavouriteActivityTypeRequest,
  ReorderFavouriteActivityTypeResponse,
} from "generated/legebill/site/activitytype/v4/activity_type_pb"
import * as Actions from "../actions"
import { grpc } from "app/rpc/executor"
import { activityTypeServiceClient } from "app/rpc/client"
import { t } from "@lingui/macro"
import { showSnackBar } from "../../snackbar/actions"

type ReorderFavouriteActivityTypeRpc = (request: ReorderFavouriteActivityTypeRequest) => Observable<ReorderFavouriteActivityTypeResponse>

export const reorderFavouriteActivityType = (reorderFavouriteActivityTypeRpc: ReorderFavouriteActivityTypeRpc) =>
  (action$: Observable<Action>): Observable<Action> =>
    action$.pipe(
      filter(Actions.reorderFavouriteActivityType.match),
      mergeMap(({ payload: { request, siteId, }}) => of(request).pipe(
        mergeMap(reorderFavouriteActivityTypeRpc),
        map(_ => Actions.fetchFavouriteActivityTypes({ siteId })),
        catchError(_ => of(showSnackBar({
          message: t({
            id: "msg_reorder_favourite_activity_type_failed",
            message: "Failed to reorder favourite activity type. Please try again in a couple of minutes. If the error persists, please contact support@wisetime.com."
          }),
          messageType: "ERROR",
        }))),
      )),
    )

const reorderFavouriteActivityTypeRpc = (request: ReorderFavouriteActivityTypeRequest): Observable<ReorderFavouriteActivityTypeResponse> =>
  grpc(() => activityTypeServiceClient.reorderFavouriteActivityType(request, null))

export default reorderFavouriteActivityType(reorderFavouriteActivityTypeRpc)
